import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"


const Menu = ({ className }) => {

   const data = useStaticQuery(graphql`
       query {
           wpMenu(locations: { eq: PRIMARY_MENU }) {
               id
               name
               menuItems {
                   nodes {
                       id
                       label
                       title
                       path
                       parentId
                   }
               }
           }
       }
   `)

   if (data.wpMenu.menuItems) {
       const menuItems = data.wpMenu.menuItems.nodes

       return (
           <div className={className}>
           {
               menuItems &&
               menuItems.map((menuItem, index) => (
                   <Link key={index} to={menuItem.path} title={menuItem.label}>{menuItem.label}</Link>
               ))
           }
           </div>
       )
   }

}

export default Menu
